<template>
  <v-container
      fluid
      grid-list-md
      v-if="selectedPlan !== null && selectedPlan !== undefined"
  >
    <v-layout row wrap>
      <!--   Put Sub modules here   -->
      <material-stats-card
          :color="$vuetify.theme.themes.light.secondary"
          icon="mdi-cog"
          :value="$t('views.opt_outs.settings')"
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
                text
                color="primary"
                @click="
                $router.push({
                  name: 'opt-out-settings',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("globals.view") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
          :color="$vuetify.theme.themes.light.secondary"
          icon="mdi-account-minus"
          :value="$t('views.opt_outs')"
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
                text
                color="primary"
                @click="
                $router.push({
                  name: 'opt-outs-list',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("globals.view") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
          :color="$vuetify.theme.themes.light.secondary"
          icon="mdi-credit-card"
          :value="$t('Reimbursements')"
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
                text
                color="primary"
                @click="
                $router.push({
                  name: 'opt-out-reimbursements',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("globals.view") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
    </v-layout>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
          :size="70"
          :width="7"
          color="accent"
          indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import {planSetter} from "../mixins/planSetter";

export default {
  data() {
    return {
      //
    };
  },
  mixins: [planSetter],
  computed: {
    ...mapGetters("common", {selectedPlan: "plan"}),
    ...mapGetters("common", ["messages"]),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("plansMembers", ["planOptions", "planIdentity"]),
  },
  methods: {},
};
</script>
